/**
 * Web Push — ثبتِ سرویس‌ورکر و اشتراکِ اعلان.
 *
 * چرا این‌طوری:
 *  • سرویس‌ورکر فقط وقتی ثبت می‌شود که کاربر «فعال‌سازی» را بزند یا قبلاً
 *    اجازه داده باشد؛ هیچ‌چیزِ اضافه‌ای روی مرورگر تحمیل نمی‌شود.
 *  • کلیدِ عمومی از سرور می‌آید (SiteSetting) — در کد نیست.
 */
import api from './api/client'

const b64ToU8 = (base64) => {
    const pad = '='.repeat((4 - (base64.length % 4)) % 4)
    const raw = atob((base64 + pad).replace(/-/g, '+').replace(/_/g, '/'))
    const out = new Uint8Array(raw.length)
    for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i)
    return out
}

export const pushSupported = () =>
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window

export const pushPermission = () =>
    (pushSupported() ? Notification.permission : 'denied')

export const registerSW = async () => {
    if (!pushSupported()) return null
    try {
        return await navigator.serviceWorker.register('/sw.js', { scope: '/' })
    } catch (e) {
        return null
    }
}

export const isSubscribed = async () => {
    if (!pushSupported()) return false
    try {
        const reg = await navigator.serviceWorker.getRegistration('/')
        if (!reg) return false
        const sub = await reg.pushManager.getSubscription()
        return !!sub
    } catch (e) {
        return false
    }
}

/** فعال‌سازی: اجازه + ثبت سرویس‌ورکر + اشتراک + ارسال به سرور */
export const enablePush = async () => {
    if (!pushSupported()) return { ok: false, error: 'مرورگر از اعلان پشتیبانی نمی‌کند.' }

    let info
    try {
        info = (await api.get('users/push/public-key/')).data
    } catch (e) {
        return { ok: false, error: 'دریافت تنظیمات اعلان ناموفق بود.' }
    }
    if (!info || !info.enabled || !info.key) {
        return { ok: false, error: 'اعلان روی این سرور فعال نشده است.' }
    }

    const perm = await Notification.requestPermission()
    if (perm !== 'granted') return { ok: false, error: 'اجازهٔ اعلان داده نشد.' }

    const reg = (await registerSW()) || (await navigator.serviceWorker.ready)
    if (!reg) return { ok: false, error: 'ثبت سرویس‌ورکر ناموفق بود.' }

    let sub = await reg.pushManager.getSubscription()
    if (!sub) {
        sub = await reg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: b64ToU8(info.key),
        })
    }
    try {
        await api.post('users/push/subscribe/', sub.toJSON())
    } catch (e) {
        return { ok: false, error: 'ثبت اشتراک در سرور ناموفق بود.' }
    }
    return { ok: true }
}

export const disablePush = async () => {
    try {
        const reg = await navigator.serviceWorker.getRegistration('/')
        const sub = reg && (await reg.pushManager.getSubscription())
        if (!sub) return { ok: true }
        const data = sub.toJSON()
        await api.post('users/push/unsubscribe/', { endpoint: data.endpoint })
        await sub.unsubscribe()
        return { ok: true }
    } catch (e) {
        return { ok: false, error: 'لغو اعلان ناموفق بود.' }
    }
}

export const sendTest = async () => {
    try {
        const r = await api.post('users/push/test/')
        return { ok: true, sent: r.data.sent }
    } catch (e) {
        return { ok: false, error: 'ارسال اعلان آزمایشی ناموفق بود.' }
    }
}
